import { render, staticRenderFns } from "./DevListList.vue?vue&type=template&id=451043e6&scoped=true&"
import script from "./DevListList.vue?vue&type=script&lang=js&"
export * from "./DevListList.vue?vue&type=script&lang=js&"
import style0 from "./DevListList.vue?vue&type=style&index=0&id=451043e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451043e6",
  null
  
)

export default component.exports